import { render, staticRenderFns } from "./VatInput.vue?vue&type=template&id=2b4e780c&"
import script from "./VatInput.vue?vue&type=script&lang=ts&"
export * from "./VatInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports